module.exports = __webpack_public_path__ + "static/council-d0b1cacebf9864c8e2d2f3c41e2b3179.svg";